module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('home-header'), _vm._v(" "), _c('div', {
    staticClass: "wrapper pt-3 pb-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "bg-white p-3 mb-3"
  }, [(_vm.scope == 'public_b') ? _c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("B2B业务数据集\n            ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content pt-1"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": _vm.btn_add_new
    }
  }, [_vm._v("新建数据集")])], 1)]) : _c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("B2C业务数据集\n            ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content pt-1"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": _vm.btn_add_new
    }
  }, [_vm._v("新建数据集")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content pt-1"
  }, [_c('label', [_vm._v("业务类型：")]), _vm._v(" "), _c('el-radio-group', {
    on: {
      "change": _vm.radio_change
    },
    model: {
      value: (_vm.scope),
      callback: function($$v) {
        _vm.scope = $$v
      },
      expression: "scope"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "public_b"
    }
  }, [_vm._v("B2B")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "public_c"
    }
  }, [_vm._v("B2C")])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {}, [_c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "search_list",
    attrs: {
      "id": "mapContainer"
    }
  }, [(_vm.listLoading) ? _c('div', {
    staticClass: "item"
  }, [_vm._m(2)]) : (_vm.pkgList.length == 0) ? _c('div', [_vm._m(3)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "pl-3 pb-2 pt-2 row"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": this.page.size,
      "total": this.page.total,
      "current-page": this.page.index + 1
    },
    on: {
      "current-change": _vm.pagechange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, _vm._l((_vm.pkgList), function(item, index) {
    return _c('div', {
      staticClass: "float-left pl-3 pb-3"
    }, [_c('div', {
      staticClass: "dataset-card el-card is-always-shadow card-body"
    }, [_c('div', {
      staticClass: "cursor-pointer image-container",
      on: {
        "click": function($event) {
          return _vm.show_item_detail(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageUrl(item),
        "alt": "主图"
      }
    })]), _vm._v(" "), _c('h6', {
      staticClass: "pt-3 card-title cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.show_item_detail(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.remark) ? _c('p', {
      staticClass: "card-text"
    }, [_vm._v("\n                        " + _vm._s(item.remark.length > 25 ? item.remark.substring(0, 25) + " ..." : item.remark))]) : _c('p', {
      staticClass: "card-text"
    }, [_vm._v("通过AI模型从大数据平台挖掘生成该数据集")]), _vm._v(" "), _c('div', {
      staticClass: "mb-2"
    }, [_c('el-tag', {
      attrs: {
        "type": "primary",
        "effect": "dark",
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "el-icon-office-building"
    }), _vm._v(" " + _vm._s(Math.round(item.entCount / 10000) + '万') + "\n                        ")]), _vm._v(" "), _c('el-tag', {
      attrs: {
        "type": "success",
        "effect": "dark",
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "el-icon-s-custom"
    }), _vm._v(" " + _vm._s(Math.round(item.humCount / 10000) + '万') + "\n                        ")]), _vm._v(" "), _c('el-tag', {
      attrs: {
        "type": "info",
        "effect": "dark",
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "el-icon-phone"
    }), _vm._v(" " + _vm._s(Math.round(item.md5Count / 10000) + '万') + "\n                        ")])], 1), _vm._v(" "), _c('div', [_c('el-button', {
      attrs: {
        "type": "",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.show_item_detail(item)
        }
      }
    }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.btn_export_data(item)
        }
      }
    }, [_vm._v("导出")])], 1)])])
  }), 0)])])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title_add_pkg,
      "visible": _vm.dlg_edit_item,
      "close-on-click-modal": true,
      "width": "750px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_edit_item = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "pr-4",
    attrs: {
      "model": _vm.sltPkg,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    model: {
      value: (_vm.sltPkg.name),
      callback: function($$v) {
        _vm.$set(_vm.sltPkg, "name", $$v)
      },
      expression: "sltPkg.name"
    }
  }), _vm._v(" "), (_vm.sltPkg.img) ? _c('label', [_vm._v(_vm._s(_vm.getImageUrl(_vm.sltPkg)))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.actionUrl,
      "headers": _vm.myHeaders,
      "list-type": "picture-card",
      "file-list": _vm.getImageList(_vm.sltPkg),
      "on-change": _vm.handleChange,
      "on-success": _vm.upload_success,
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据简介"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "529px"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.sltPkg.remark),
      callback: function($$v) {
        _vm.$set(_vm.sltPkg, "remark", $$v)
      },
      expression: "sltPkg.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司数量"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    model: {
      value: (_vm.sltPkg.entCount),
      callback: function($$v) {
        _vm.$set(_vm.sltPkg, "entCount", $$v)
      },
      expression: "sltPkg.entCount"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("高管数量")]), _vm._v(" "), _c('el-input', {
    staticClass: "item_w",
    model: {
      value: (_vm.sltPkg.humCount),
      callback: function($$v) {
        _vm.$set(_vm.sltPkg, "humCount", $$v)
      },
      expression: "sltPkg.humCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "md5数量"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    model: {
      value: (_vm.sltPkg.md5Count),
      callback: function($$v) {
        _vm.$set(_vm.sltPkg, "md5Count", $$v)
      },
      expression: "sltPkg.md5Count"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("orderId")]), _vm._v(" "), _c('el-input', {
    staticClass: "item_w",
    model: {
      value: (_vm.sltPkg.orderId),
      callback: function($$v) {
        _vm.$set(_vm.sltPkg, "orderId", $$v)
      },
      expression: "sltPkg.orderId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据包"
    }
  }, [_c('el-transfer', {
    attrs: {
      "titles": ['可用数据包', '已选数据包'],
      "data": _vm.folderList,
      "props": {
        key: 'id',
        label: 'name'
      }
    },
    model: {
      value: (_vm.sltPkg.folders),
      callback: function($$v) {
        _vm.$set(_vm.sltPkg, "folders", $$v)
      },
      expression: "sltPkg.folders"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.update_pkg.apply(null, arguments)
      }
    }
  }, [_vm._v("立即提交")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dlg_edit_item = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "数据包详细",
      "visible": _vm.dlg_pkg_detail,
      "close-on-click-modal": true,
      "size": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_pkg_detail = $event
      }
    }
  }, [_c('div', {
    staticClass: "col-right"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block search_list pt-3 pl-3 pr-0"
  }, [(_vm.fldlistLoading) ? _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "h-420"
  }, [_c('div', {
    staticClass: "loading_position"
  }, [_c('i', {
    staticClass: "el-icon-loading",
    staticStyle: {
      "font-size": "25px",
      "margin-left": "10px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-block"
  }, [_vm._v("加载中...")])])])]) : (_vm.dataList == null || _vm.dataList.length == 0) ? _c('div', [_c('div', {
    staticClass: "h-435"
  }, [_c('div', {
    staticClass: "loading_position"
  }, [_c('span', {
    staticClass: "d-block"
  })])])]) : _c('div', {
    staticClass: "main_content"
  }, [_c('div', {
    staticClass: "pb-2"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": this.draw_page.size,
      "total": this.draw_page.total,
      "current-page": this.draw_page.index + 1
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _vm._l((_vm.dataList), function(item, index) {
    return _c('div', {
      staticClass: "item pr-3"
    }, [_c('el-card', {
      staticStyle: {
        "height": "auto"
      },
      attrs: {
        "shadow": "always"
      }
    }, [_c('div', {
      staticClass: "content-box"
    }, [(item.company_name) ? _c('div', [_c('div', {
      staticClass: "title"
    }, [_c('span', [_vm._v(_vm._s(item.company_name))])]), _vm._v(" "), (item.legal_person) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("法人：" + _vm._s(item.legal_person) + "\n                        "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.getHumDetail(item)
        }
      }
    }, [_vm._v(" (更多高管)")])])]) : _vm._e(), _vm._v(" "), (item.reg_capital) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("注册资金：" + _vm._s(item.reg_capital))])]) : _vm._e(), _vm._v(" "), (item.reg_date) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("成立时间：" + _vm._s(_vm._f("formatDateTime")(item.reg_date)))])]) : _vm._e(), _vm._v(" "), (item.address) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("地址：" + _vm._s(item.address))])]) : _vm._e()]) : _c('div', [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getInfoDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (item.gender) ? _c('div', {
      staticClass: "content"
    }, [(item.gender == 'female') ? _c('label', [_vm._v("性别：女")]) : (item.gender == 'male') ? _c('label', [_vm._v("性别：男")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.birthDay) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("出生日期：" + _vm._s(item.birthDay))])]) : _vm._e(), _vm._v(" "), (item.adMd5) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("投放ID："), _c('a', {
      on: {
        "click": function($event) {
          return _vm.getHumDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item.adMd5))])])]) : _vm._e(), _vm._v(" "), (item.phone) ? _c('div', {
      staticClass: "content"
    }, [_c('label', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getPhoneNumber(item.id, item.md5)
        }
      }
    }, [_vm._v("电话：" + _vm._s(item.phone))])]) : _vm._e(), _vm._v(" "), (item.mobileProv) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("地区：" + _vm._s(item.mobileProv) + "," + _vm._s(item.mobileCity))])]) : _vm._e(), _vm._v(" "), (item.companyName) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("公司："), _c('span', [_vm._v(" " + _vm._s(item.companyName))])])]) : _vm._e(), _vm._v(" "), (item.typeJoin) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("职位："), _vm._l((item.typeJoin), function(i, v) {
      return _c('span', [_vm._v("\n                        " + _vm._s(i.trim()) + "\n                      ")])
    })], 2)]) : _vm._e()])])])], 1)
  }), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": this.draw_page.size,
      "total": this.draw_page.total,
      "current-page": this.draw_page.index + 1
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 2)])])])]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "高管列表",
      "visible": _vm.dlg_ent_hum_detail,
      "size": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_ent_hum_detail = $event
      }
    }
  }, [(_vm.humlistLoading == true) ? _c('div', [_c('div', {
    staticClass: "h-420"
  }, [_c('div', {
    staticClass: "loading_position",
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading",
    staticStyle: {
      "font-size": "25px",
      "margin-left": "10px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-block"
  }, [_vm._v(_vm._s(_vm.loading_info))])])])]) : _c('div', [(_vm.ent_hum_list.length == 0) ? _c('div', {
    staticClass: "h-420"
  }, [_c('div', {
    staticClass: "loading_position",
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_c('span', {
    staticClass: "d-block"
  }, [_vm._v("无数据")])])]) : _c('div', [_c('h1', {
    staticClass: "p-3",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.dlg_hum_detail_title + "（" + _vm.ent_hum_list.length + "）人") + "\n        ")])]), _vm._v(" "), _vm._l((_vm.ent_hum_list), function(item, index) {
    return _c('div', {
      staticClass: "pl-3 pb-3 pr-3"
    }, [_c('el-card', {
      staticStyle: {
        "height": "auto"
      },
      attrs: {
        "shadow": "always"
      }
    }, [_c('div', {
      staticClass: "content-box"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getInfoDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (item.gender) ? _c('div', {
      staticClass: "content"
    }, [(item.gender == 'female') ? _c('label', [_vm._v("性别：女")]) : (item.gender == 'male') ? _c('label', [_vm._v("性别：男")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.birthDay) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("出生日期：" + _vm._s(item.birthDay))])]) : _vm._e(), _vm._v(" "), (item.phone) ? _c('div', {
      staticClass: "content"
    }, [_c('label', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getPhoneNumber(item.id, item.md5)
        }
      }
    }, [_vm._v("OneID：" + _vm._s(item.md5))])]) : _vm._e(), _vm._v(" "), _vm._l((item.md5_list), function(md5, idx) {
      return _c('div', {
        staticClass: "content"
      }, [_c('label', {
        on: {
          "click": function($event) {
            return _vm.getPhoneNumber(item.id, md5)
          }
        }
      }, [_vm._v("OneID：" + _vm._s(md5))])])
    }), _vm._v(" "), (item.typeJoin) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("职位："), _vm._l((item.typeJoin), function(i, v) {
      return _c('span', [_vm._v(_vm._s(i.trim()) + "\n                      ")])
    })], 2)]) : _vm._e(), _vm._v(" "), (item.share) ? _c('div', [_c('div', [_vm._v("股份：" + _vm._s(item.share))])]) : _vm._e()], 2)])], 1)
  })], 2)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "数据集",
      "visible": _vm.dlg_pkg_use,
      "width": "750px",
      "close-on-click-modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_pkg_use = $event
      }
    }
  }, [_c('table', {
    staticStyle: {
      "height": "700px"
    }
  }, [_c('tr', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "margin-top": "65px"
    }
  }, [_c('el-steps', {
    attrs: {
      "direction": "vertical",
      "active": _vm.step_index
    }
  }, [_c('el-step', {
    attrs: {
      "title": "数据信息",
      "description": "数据集基本信息以及所包含的数据包"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "数据筛选",
      "description": "对数据集内容做地域和性别简单筛选"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "广告推送",
      "description": "将数据包推送到合适的广告平台"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "充值支付",
      "description": "支付数据服务费和广告平台费用"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "680px"
    }
  }, [_c('div', {
    staticClass: "pl-4",
    attrs: {
      "hidden": _vm.step_index != 0
    }
  }, [_c('h5', [_vm._v("数据集介绍")]), _vm._v(" "), _c('div', {
    staticClass: "pb-4"
  }, [_c('div', [_c('span', {
    staticClass: "item_grid"
  }, [_c('label', [_vm._v("企业总量：")]), _c('font', {
    attrs: {
      "color": "orange"
    }
  }, [_vm._v(_vm._s(this.sltPkg.entCount > 0 ? this.sltPkg.entCount.toLocaleString() : 0))])], 1), _vm._v(" "), _c('span', {}, [_c('label', [_vm._v("人群总量：")]), _c('font', {
    attrs: {
      "color": "orange"
    }
  }, [_vm._v(_vm._s(this.sltPkg.humCount > 0 ? this.sltPkg.humCount.toLocaleString() : 0))])], 1)]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "item_grid"
  }, [_c('label', [_vm._v("MD5总量：")]), _c('font', {
    attrs: {
      "color": "orange"
    }
  }, [_vm._v(_vm._s(this.sltPkg.md5Count > 0 ? this.sltPkg.md5Count.toLocaleString() : 0))])], 1), _vm._v(" "), _c('span', {}, [_c('label', [_vm._v("更新时间：")]), _vm._v(_vm._s(_vm._f("formatDateTime")(this.sltPkg.addtime)))])]), _vm._v(" "), _c('div', [_c('span', {}, [_c('label', [_vm._v("详细描述：")]), _vm._v(_vm._s(this.sltPkg.remark))])])]), _vm._v(" "), _c('h5', [_vm._v("包含的数据包")]), _vm._v(" "), _vm._l((this.sltPkg.folderList), function(item, index) {
    return _c('div', {
      staticClass: "pb-3"
    }, [_c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n                "), _c('el-tag', {
      staticClass: "cursor-pointer mr-2",
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.search_action(item)
        }
      }
    }, [_vm._v("查看")])], 1), _vm._v(" "), _c('div', [_c('div', [_vm._v(_vm._s(item.remark) + "\n                ")]), _vm._v(" "), (item.entCount > 0) ? _c('span', [_vm._v("企业数量："), _c('font', {
      attrs: {
        "color": "orange"
      }
    }, [_vm._v(_vm._s(item.entCount.toLocaleString()))]), _vm._v("家，")], 1) : _vm._e(), _vm._v(" "), (item.humCount > 0) ? _c('span', [_vm._v("人群数量："), _c('font', {
      attrs: {
        "color": "orange"
      }
    }, [_vm._v(_vm._s(item.humCount.toLocaleString()))]), _vm._v("人，")], 1) : _vm._e(), _vm._v(" "), (item.md5Count > 0) ? _c('span', [_vm._v("MD5数据："), _c('font', {
      attrs: {
        "color": "orange"
      }
    }, [_vm._v(_vm._s(item.md5Count.toLocaleString()))]), _vm._v("条")], 1) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "hidden": _vm.step_index != 1
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('h4', [_vm._v("数据筛选")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地区"
    }
  }, [_c('el-select', {
    staticClass: "item_w",
    attrs: {
      "placeholder": "请选择省份",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getProv($event)
      }
    },
    model: {
      value: (_vm.form.adProvs),
      callback: function($$v) {
        _vm.$set(_vm.form, "adProvs", $$v)
      },
      expression: "form.adProvs"
    }
  }, _vm._l((_vm.provs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄范围"
    }
  }, [_c('el-date-picker', {
    staticClass: "item_w",
    attrs: {
      "type": "monthrange",
      "align": "left",
      "unlink-panels": "",
      "range-separator": "——",
      "start-placeholder": "开始",
      "end-placeholder": "结束",
      "picker-options": _vm.birthOptions
    },
    model: {
      value: (_vm.form.date_range),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_range", $$v)
      },
      expression: "form.date_range"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "不筛选"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.delivery),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery", $$v)
      },
      expression: "form.delivery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "male"
    },
    model: {
      value: (_vm.form.gender),
      callback: function($$v) {
        _vm.$set(_vm.form, "gender", $$v)
      },
      expression: "form.gender"
    }
  }, [_vm._v("男性")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "female"
    },
    model: {
      value: (_vm.form.gender),
      callback: function($$v) {
        _vm.$set(_vm.form, "gender", $$v)
      },
      expression: "form.gender"
    }
  }, [_vm._v("女性")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": ""
    },
    model: {
      value: (_vm.form.gender),
      callback: function($$v) {
        _vm.$set(_vm.form, "gender", $$v)
      },
      expression: "form.gender"
    }
  }, [_vm._v("不限")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticClass: "item_w_400",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("立即提交")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dlg_share = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "hidden": _vm.step_index != 2
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('h4', [_vm._v("广告推送")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授权平台"
    }
  }, [_c('el-select', {
    staticClass: "item_w",
    attrs: {
      "placeholder": "请选择授权区域"
    },
    model: {
      value: (_vm.form.region),
      callback: function($$v) {
        _vm.$set(_vm.form, "region", $$v)
      },
      expression: "form.region"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "腾讯广告",
      "value": "tencent"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "巨量广告",
      "value": "byte"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小红书广告",
      "value": "xiaohongshu"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "抖音广告",
      "value": "douyin"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "平台ID"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授权时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticClass: "item_w",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.date1),
      callback: function($$v) {
        _vm.$set(_vm.form, "date1", $$v)
      },
      expression: "form.date1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "选择时间"
    },
    model: {
      value: (_vm.form.date2),
      callback: function($$v) {
        _vm.$set(_vm.form, "date2", $$v)
      },
      expression: "form.date2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "即时推送"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.delivery),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery", $$v)
      },
      expression: "form.delivery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授权类型"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "仅广告投放",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "可分析",
      "name": "type2"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "可分享",
      "name": "type3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticClass: "item_w_400",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("立即提交")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dlg_share = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "hidden": _vm.step_index != 3
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticClass: "mb-1",
    attrs: {
      "label": ""
    }
  }, [_c('h4', [_vm._v("支付")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mb-1",
    attrs: {
      "label": "使用方式"
    }
  }, [_c('label', [_vm._v("广告推送")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mb-1",
    attrs: {
      "label": "数量"
    }
  }, [_c('label', [_vm._v(_vm._s(Math.round(this.sltPkg.md5Count / 10000)) + "万条")]), _vm._v(" "), _c('a', {
    staticClass: "cursor-pointer pl-2",
    attrs: {
      "target": "_blank",
      "href": this.apiUrl + '/files/sample_md5.txt'
    }
  }, [_vm._v("查看样例")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mb-1",
    attrs: {
      "label": "使用时间"
    }
  }, [_c('label', [_vm._v("180天")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mb-1",
    attrs: {
      "label": "价格"
    }
  }, [_c('label', [_vm._v("面议")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mb-1",
    attrs: {
      "label": "支付"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "12px",
      "width": "220px"
    },
    attrs: {
      "src": "/static/img/new-weixin.png",
      "alt": "收款码"
    }
  })])], 1)], 1)])])]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.step_pre
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.step_next
    }
  }, [_vm._v("下一步")])], 1)]), _vm._v(" "), _c('home-footer'), _vm._v(" "), _c('export-data', {
    attrs: {
      "dlg_export_model": _vm.dlg_export_model,
      "form": _vm.form
    },
    on: {
      "exportClose": function($event) {
        _vm.dlg_export_model = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('label', [_vm._v("规模庞大的高商业价值的B2B业务数据集，覆盖多种应用场景，可上传到广告平台实现精准投放，开箱即用。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('label', [_vm._v("覆盖B2C业务多种应用场景，可上传到广告平台实现精准投放，开箱即用。支持个性化定制，支持批量下载。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-420"
  }, [_c('div', {
    staticClass: "loading_position"
  }, [_c('i', {
    staticClass: "el-icon-loading",
    staticStyle: {
      "font-size": "25px",
      "margin-left": "10px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-block"
  }, [_vm._v("加载中...")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-435"
  }, [_c('div', {
    staticClass: "loading_position"
  }, [_c('span', {
    staticClass: "d-block"
  }, [_vm._v("无数据，请重试")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-432a20d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/Package.vue
// module id = 273
// module chunks = 1